import styled from "styled-components";
import { Form, Typography, Button, Input } from "antd";

const { Title, Paragraph } = Typography;

export const StyledTitle = styled(Title)``;

export const StyledParagraph = styled(Paragraph)`
  &&& {
    width: 70%;
    text-align: center;
  }
`;

export const StyledFormTitle = styled(Form.Item)`
  &&& {
    width: 100%;
  }
`;

export const StyledSubmitButton = styled(Button)`
  &&.ant-btn-primary {
    background-color: #b80000;
    font-size: 16px;
    width: 30%;
    height: 3rem;
    margin-top: 20px;
    margin-bottom: 25px;
    border-radius: 50px;
    border-color: #b80000;
    display: flex;
    align-items: center;
    justify-content: center;
    place-self: center;
    color: white;
    font-family: "Lato";

    &:hover {
      background-color: white;
      border-color: #b80000;
      color: #b80000;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;

export const StyledInput = styled(Input)`
  && {
    border-radius: 0px;
    width: 100%;
  }
`;

export const StyledTextArea = styled(Input.TextArea)`
  && {
    border-radius: 0px;
    width: 100%;
  }
`;

export const StyledUpload = styled.div`
  .ant-upload-list-picture-card-container,
  .ant-upload-select {
    border-radius: 0px;
  }
`;

export const FormContainer = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 2rem 2rem 0 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  max-width: 1200px;
  margin: 30px auto;
  border: 1px solid #e1e8ed;

  @media (max-width: 968px) {
    padding: 20px;
    margin: 15px;
  }
`;

export const FormSection = styled.div`
  display: flex;
  gap: 3rem;
  align-items: flex-start;

  @media (max-width: 968px) {
    flex-direction: column;
    gap: 0px;
  }
`;

export const LeftSection = styled.div`
  flex: 1;
  min-width: 0;
  width: 100%;

  @media (max-width: 968px) {
    width: 100%;
  }
`;

export const RightSection = styled.div`
  flex: 1;
  min-width: 0;
  width: 100%;

  @media (max-width: 968px) {
    width: 100%;
  }
`;
